module.exports = {
  messages: {
    BUTTON_SEND: 'Send',
    CONTACT_FORM_CHOOSE_SUBJECT: 'Please choose a subcategory.',
    CONTACT_FORM_CHOOSE_TOPIC: 'Please choose a category.',
    CONTACT_FORM_CONFIRM_NEW_EMAIL_ADDRESS:
      '<strong>Please activate your e-mail address now:</strong><br/>Click the link in the activation e-mail we sent to <strong>{email}</strong>.',
    CONTACT_FORM_FILE_UPLOAD_CHOOSE_BUTTON: 'Add',
    CONTACT_FORM_FILE_UPLOAD_ERR_FILE_TOO_LARGE:
      'Unfortunately the file <strong>{fileName}</strong> exceeds the {maxFileSize} MB limit.',
    CONTACT_FORM_FILE_UPLOAD_ERR_TOO_MANY_FILES:
      'You can add up to {maxAmount} files.',
    CONTACT_FORM_FILE_UPLOAD_ERR_UNSUPPORTED_FORMAT:
      '<strong>{fileName}</strong>: Please select a JPEG, PNG or PDF file',
    CONTACT_FORM_FILE_UPLOAD_HEADLINE: 'Upload an image or a document',
    CONTACT_FORM_FILE_UPLOAD_PROGRESS_SUFFIX: 'uploaded',
    CONTACT_FORM_FILE_UPLOAD_SIZE_INFO:
      'Add up to {maxAmount} files (max. 10 MB in total).',
    CONTACT_FORM_FILE_UPLOAD_TYPE_INFO: 'Accepted formats: JPG, PNG, PDF',
    CONTACT_FORM_FILE_UPLOAD_UNAVAILABLE:
      "File uploads aren't available right now. Please try again later.",
    CONTACT_FORM_OKAY:
      "Your message has been sent and we'll process it as soon as possible.",
    CONTACT_FORM_SERVER_ERROR: 'Something went wrong. Please try again later.',
    CONTACT_FORM_THANKS: 'Thank you!',
    CONTACT_FORM_TO_STARTPAGE: 'Continue to homepage',
    CONTACT_FORM_USER_EMAIL_INFO:
      'Please note that the response will be sent to <strong>{email}</strong>. If this e-mail address is outdated, please change it <strong><a>here</a></strong>.',
    SUPPORTHTML_ERRFORM:
      'One or more errors occurred while completing the form. Please correct the fields indicated.',
    SUPPORTHTML_HELP_DESCRIPTION:
      '<p>Feel free to get in touch with us.</p>\n<p><strong>Tip:</strong> Check out our <a target="_blank" href="https://faq.xing.com">XING help section</a> as the answer to your question might be there.</p>\n<p>Need swift assistance? Give us a call:  +49 40 419 131 0</p>\n<p>\n  <ul>\n    <li>XING customer service: Monday to Friday 9:00-16:00 CET*</li>\n    <li>Recruiting solutions customer service: Monday to Thursday 9:00-12:00 CET*</li>\n  </ul>\n</p>\n<p>(*excluding public holidays in Germany).</p>',
    SUPPORTHTML_HELP_DESCRIPTION_ONLYFY:
      '<p>\nFor questions about recruiting solutions or account support, head over to the <a target="_blank" href="https://recruiting-help.xing.com/">Help Center</a>.\n</p>\n<p>\nOtherwise, feel free to message us <a target="_blank" href="https://help.onlyfy.com/hc/en-us/requests/new">here</a>.\n</p>',
    SUPPORTHTML_MAIL: 'Your e-mail address (so we can reply)',
    SUPPORTHTML_SENDNAME: 'Your first and last name',
    SUPPORTHTML_SUB0: 'How can we help you?',
  },
};
